var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel"},[_c('Frame',{attrs:{"sum":_vm.leftSum,"align":"left"}}),_c('Price',{attrs:{"price":_vm.price,"color":_vm.color}}),_c('Frame',{attrs:{"sum":_vm.rightSum}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }